import {useMutation, UseMutationResult} from '@tanstack/react-query';
import {useLocale} from 'state/locale';
import Api from 'types/api';
import {request} from 'utils/request-axios';

type PossibleResponses = Api.Response.SuccessAxios;

const useDeleteApprovalFlow = (): UseMutationResult<
    PossibleResponses,
    Error,
    {mid: string; partnerMid: string}
> => {
    const locale = useLocale();

    return useMutation({
        mutationFn: ({mid, partnerMid}) =>
            request({
                locale,
                method: 'DELETE',
                url: `/api/partner/${partnerMid}/approval/template/${mid}/`,
            }),
    });
};

export default useDeleteApprovalFlow;

export const useModifyApprovalSettings = (): UseMutationResult<
    PossibleResponses,
    Error,
    Record<string, boolean>
> => {
    const locale = useLocale();

    return useMutation({
        mutationFn: (formData) =>
            request({
                formData,
                locale,
                method: 'POST',
                url: `/approval/settings/edit/`,
            }),
    });
};

export const useCreateApprovalFlow = (): UseMutationResult<
    PossibleResponses,
    Error,
    {
        formData: {
            document_type: string;
            name: string;
            rules: {rules: []};
            steps: {position: number; team_mid: string}[];
        };
        partnerMid: string;
    }
> => {
    const locale = useLocale();

    return useMutation({
        mutationFn: ({formData, partnerMid}) =>
            request({
                formData,
                locale,
                method: 'POST',
                url: `/api/partner/${partnerMid}/approval/template/`,
            }),
    });
};
export const useModifyApprovalFlow = (): UseMutationResult<
    PossibleResponses,
    Error,
    {
        formData: {
            document_type: string;
            name: string;
            rules: {rules: []};
            steps: {position: number; team_mid: string}[];
        };
        mid: string;
        partnerMid: string;
    }
> => {
    const locale = useLocale();

    return useMutation({
        mutationFn: ({formData, mid, partnerMid}) =>
            request({
                formData,
                locale,
                method: 'PUT',
                url: `/api/partner/${partnerMid}/approval/template/${mid}/`,
            }),
    });
};
